import type { Credentials, LoginServiceErrors } from 'login/types/loginService'
import type { UserResponse } from 'types/session/user'
import { StatusCode } from 'types/statusCodes'
import { env } from 'utils/envManager'

/**
 * @throws {{...Error, cause: LoginServiceErrorCause}}
 */
export const loginService = async (
	credentials: Credentials,
	isCheckout: boolean
): Promise<UserResponse | LoginServiceErrors | null> => {
	const url = new URL(
		`${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-online-customer-service/customer/v1/login`
	)

	if (isCheckout) {
		url.searchParams.append('isCheckout', 'true')
	}

	const response = await fetch(url.href, {
		headers: { 'Content-Type': 'application/json' },
		method: 'POST',
		body: JSON.stringify(credentials),
		next: { revalidate: 0 },
	})

	if (response.ok || response.status === StatusCode.BAD_REQUEST) {
		const responseJson = (await response.json()) as
			| UserResponse
			| LoginServiceErrors

		return responseJson as UserResponse
	}

	console.error(`Login service error with status ${response.status}.`)
	return null
}
